export default __webpack_public_path__ + "static/media/tokens.13fff816.png";